import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=01901ade&scoped=true&"
import script from "./loader.ts?vue&type=script&lang=ts&"
export * from "./loader.ts?vue&type=script&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=01901ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01901ade",
  null
  
)

export default component.exports